import script from "./WebRotate.vue?vue&type=script&setup=true&lang=js"
export * from "./WebRotate.vue?vue&type=script&setup=true&lang=js"

import "./WebRotate.vue?vue&type=style&index=0&id=51d470a1&lang=scss"

const __exports__ = script;

export default __exports__